module.exports = __webpack_public_path__ + "img/fottom-load.de57caff.gif";